import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {GameAssets} from "../GameAssets";
import {gsap} from "gsap";
import {AnimUtils} from "../utils/AnimUtils";
import {HOTB} from "../HOTB";
import {GameSounds} from "../sound/GameSounds";
import {GameUtils} from "../utils/GameUtils";

export class BigWinView extends PIXI.Container implements StageLayer {
    private _countUp: BasicBitmapCountUp;
    private _bigWinSpines: PIXI.spine.Spine[] = [];
    private _countUpDefPosY: number = 170;

    constructor() {
        super();
        this.name = "BigWinView";
        this.init();
    }

    public getLevelAnimation(countFrom: number, countTo: number, duration: number, level: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            scaleTl: gsap.core.Timeline = gsap.timeline();

        scaleTl.add(this.getCountUpScaleAnimation(0.1, "power2.in", 1.2), 0);
        scaleTl.add(this.getCountUpScaleAnimation(0.2, "power2.out", 1.0));

        tl.add([
            (): void => {
                this._bigWinSpines[level - 1].visible = true;

                if (level === 1) {
                    this.alpha = 1;
                    this._countUp.visible = true;
                    this._countUp.position.y = this._countUpDefPosY;
                }

                if (level > 1) {
                    this._bigWinSpines[level - 2].visible = false;
                    HOTB.soundPlayer.stopSound(GameSounds.BIG_WIN_LEVELS[level - 2]);
                }

                HOTB.soundPlayer.playSound(GameSounds.BIG_WIN_LEVEL_CHANGE);
                HOTB.soundPlayer.playSound(GameSounds.BIG_WIN_LEVELS[level - 1]);
            },
            AnimUtils.createTimelineForAnimation(this._bigWinSpines[level - 1], 0, "animation", false),
            scaleTl,
            this._countUp.getCountAnimation(countFrom, countTo, duration, "power1.easeOut"),
        ]);
        return tl;
    }

    public hide(duration: number = 0.0001): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this._countUp.position, {
            y: 615,
            duration: 0.3
        });

        tl.to(this, {
            alpha: 0,
            duration: duration
        });

        tl.add([
            (): void => {
                for (let i: number = 0; i < this._bigWinSpines.length; i++) {
                    AnimUtils.resetSpine(this._bigWinSpines[i], false);
                }
            },
            HOTB.gameOverlay.toggleTrimmedOverlay(GameUtils.isCapMachineGame())
        ]);

        return tl;
    }

    private init(): void {
        this.createBigWinAnims();
        this.createCountUp();
        this.hide();
    }

    private createBigWinAnims(): void {
        const container: PIXI.Container = new PIXI.Container();

        for (let i: number = 1; i <= 5; i++) {
            const bwSpine: PIXI.spine.Spine = new PIXI.spine.Spine(HOTB.assetLoader.getSpineAsset("bigWin_" + i));
            bwSpine.name = "bigWinLevel_" + i;
            bwSpine.position.set(360, 405);
            bwSpine.visible = false;
            this._bigWinSpines.push(bwSpine);
            container.addChild(bwSpine);
        }

        this.addChild(container);
    }

    private createSpine(spinePath: string): PIXI.spine.Spine {
        return AnimUtils.createNewSpine({
            path: spinePath,
            name: spinePath,
            pos: new PIXI.Point(360, 405),
            initShow: false
        });
    }

    private createCountUp(): void {
        this._countUp = new BasicBitmapCountUp({
            fontName: GameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 42,
        }, 680, new PIXI.Point(0.5, 0.5));

        this._countUp.visible = false;
        this._countUp.position.set(360, this._countUpDefPosY);
        this.addChild(this._countUp);
    }

    private getCountUpScaleAnimation(duration: number, ease: string, to: number, from?: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        if (from != undefined) {
            tl.add((): void => {
                this._countUp.scale.set(from, from)
            });
        }
        tl.to(this._countUp.scale, {duration: duration, x: to, y: to, ease: ease});

        return tl;
    }
}